import React from 'react'
import {
  TeeCardColor,
  TeeCardName,
} from '@app/components/molecules/TeeColorPicker/styled'
import * as S from './Tees.styles'

function Tees(props) {
  const { title, slopeRating, courseRating, color, onClick } = props
  return (
    <S.TeeCardButton onClick={onClick}>
      <TeeCardColor>
        <S.TeeSwatch color={color} />
      </TeeCardColor>
      <TeeCardName>
        <S.TeeName>{title}</S.TeeName>
        <S.TeeRating>
          CR<span>{Number(courseRating).toFixed(1)}</span>
        </S.TeeRating>
        <S.TeeRating>
          Slope<span>{slopeRating}</span>
        </S.TeeRating>
      </TeeCardName>
    </S.TeeCardButton>
  )
}

export default Tees
